<template>
  <div id="WizualizacjaStacja">
    <div id="Stacja" style="height: 100%;">
      <ul style="height: 100%; margin:0px">
        <li v-if="inputs.wariant2.value > 0"><img src="../assets/img/urzadzenia/wariant2.png"/></li>
        <li v-if="inputs.wariant3.value > 0"><img src="../assets/img/urzadzenia/wariant3.png"/></li>
        <li v-if="inputs.wariant4.value > 0"><img src="../assets/img/urzadzenia/wariant4.png"/></li>
        <li></li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { app } from '../mixins/app'
// import { materials } from '../mixins/materials'
import { calculation } from '../mixins/calculation'

export default {
  name: 'WizualizacjaStacja',
  mixins: [app, calculation],
  data () {
    return {
      backgroundUrl: require('../assets/img/szafa/szafa_dso_24.svg')
    }
  },
  computed: {
    ...mapGetters('app', ['outputs']),
    ...mapGetters('app', ['inputs']),
    ...mapGetters('products', ['ListaListwyZ'])
  },
  methods: {

  }
}
</script>

<style scoped>
#WizualizacjaStacja {
  height: 140px;
}
#Stacja ul li {
height: 70px;
width: 50%;
margin: 0px;
float: inline-start;
}
#Stacja ul li img{
width: 130px;
}
</style>



// WEBPACK FOOTER //
// src/components/WizualizacjaStacji.vue